@if (!isDesktop()) {
  <app-header [transparent]="true"></app-header>
}
<div
  id="content"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
  [class.desktop]="isDesktop()"
  cdkScrollable
>
  @if (isVisible() && currentLang() !== "pt") {
    <app-service-conditions-modal></app-service-conditions-modal>
  }
  <!-- Mobile view -->
  @if (!isDesktop()) {
    <app-tab-bar
      [opaque]="true"
      [icon]="true"
      [activeTabIndex]="activeTab()"
      (tabChanged)="onTabChanged($event)"
    >
      @for (tab of tabs; let i = $index; track tab) {
        <app-tab-bar-item
          class="one-of-two"
          [svg_icon]="
            tab === 'map' ? 'assets/icons/map.svg' : 'assets/icons/list.svg'
          "
          (click)="onTabChanged(i)"
        >
          {{ i18n.langString(tab) }}
        </app-tab-bar-item>
      }
    </app-tab-bar>
    <app-search-filter
      [sidebar]="false"
      [countryOrRegionSelected]="countryOrRegionSelected()"
      [plantFilterStatus]="homePageFilterStatus()"
    ></app-search-filter>
  }

  @if (isDesktop()) {
    <div
      id="desktop-sidebar"
      [class.desktop-list]="activeTab() === 1"
      [class.desktop-map]="activeTab() === 0"
      cdkScrollable
    >
      <div
        id="desktop-sidebar-inner"
        [class.scrolling]="scrolling() && activeTab() === 0"
        cdkScrollable
        [class.chrome]="isChrome()"
        [class.map]="activeTab() === 0"
      >
        <div class="title">
          <div class="navigation-icon"></div>
          <h2 class="noMargin">{{ i18n.langString("navigation") }}</h2>
        </div>

        <app-tab-bar
          [opaque]="true"
          [icon]="true"
          [activeTabIndex]="activeTab()"
          (tabChanged)="onTabChanged($event)"
        >
          @for (tab of tabs; let i = $index; track tab) {
            <app-tab-bar-item
              class="one-of-two"
              [svg_icon]="
                tab === 'map' ? 'assets/icons/map.svg' : 'assets/icons/list.svg'
              "
              (click)="onTabChanged(i)"
            >
              {{ i18n.langString(tab) }}
            </app-tab-bar-item>
          }
        </app-tab-bar>

        <app-search-filter
          [sidebar]="true"
          [countryOrRegionSelected]="countryOrRegionSelected()"
          [plantFilterStatus]="homePageFilterStatus()"
        ></app-search-filter>
      </div>
    </div>
  }
  @if (activeTab() === 1) {
    <!-- List -->
    <app-plant-list
      (statusFilterValue)="setStatusFilterValue($event)"
    ></app-plant-list>
  }
</div>
@if (activeTab() === 0) {
  <!-- Map -->
  @if (filteredPlants()) {
    <div
      id="search-info-overlay"
      class="drop-shadow"
      [class.mobile]="isMobile()"
      [class.tablet]="isTablet()"
      [class.desktop]="isDesktop()"
    >
      @if (assetCount() > 1) {
        <div class="found-wrapper">
          <h3 class="found-wrapper-title">
            {{ assetCount() }} {{ i18n.langString("equipments_found") }}
          </h3>
        </div>
      }
      @if (assetCount() === 1) {
        <div class="found-wrapper">
          <h3 class="found-wrapper-title">
            1 {{ i18n.langString("equipment_found") }}
          </h3>
        </div>
      }
      @if (assetCount() === 0) {
        <div class="found-wrapper">
          <h3 class="found-wrapper-title">
            {{ i18n.langString("no_equipments_found") }}
          </h3>
          <h5 class="marginTop24">
            {{ i18n.langString("no_equipments_found2") }}
          </h5>
        </div>
      }

      @if (allWorking()) {
        <div class="nz-multiple-status-reports nz-multiple-reports-left">
          <nz-alert
            nzType="success"
            class="nz-status-report"
            [nzMessage]="allfineTemplate"
          ></nz-alert>
          <ng-template #allfineTemplate>
            <i
              nz-icon
              nzType="icons:status-check"
              class="svg-icon fillgreen"
            ></i>
            <span class="body-bold">{{
              i18n.langString("all_equipments_working_fine")
            }}</span>
          </ng-template>
        </div>
      }

      @if (
        assetCount() > 0 &&
        (sumInActive() > 0 ||
          sumCritical() > 0 ||
          sumWarning() > 0 ||
          sumArchived() > 0)
      ) {
        <div class="nz-multiple-status-reports nz-multiple-reports-left">
          @if (sumInActive() > 0) {
            <div
              class="clickable"
              role="button"
              tabindex="0"
              (click)="onSetInactiveFilter()"
              (keyup.enter)="onSetInactiveFilter()"
              (keydown.enter)="onSetInactiveFilter()"
            >
              <nz-alert
                nzType="info"
                class="nz-status-report"
                [nzMessage]="inactiveTemplate"
              ></nz-alert>
            </div>
            <ng-template #inactiveTemplate>
              <i
                nz-icon
                nzType="icons:cross-circle"
                class="svg-icon fillblackcoral"
              ></i>
              <span class="body-bold">{{ sumInActive() }}</span>
              @if (isDesktop()) {
                <span class="body-bold sub-title-status">{{
                  i18n.langString("in_active")
                }}</span>
              }
            </ng-template>
          }

          @if (sumCritical() > 0) {
            <div
              class="clickable"
              (click)="onSetCriticalFilter()"
              role="button"
              tabindex="0"
              (keyup.enter)="onSetCriticalFilter()"
              (keydown.enter)="onSetCriticalFilter()"
            >
              <nz-alert
                nzType="error"
                class="nz-status-report"
                [nzMessage]="errorTemplate"
              ></nz-alert>
            </div>
            <ng-template #errorTemplate>
              <i
                nz-icon
                nzType="icons:status-exclamation-triangle"
                class="svg-icon fillred"
              ></i>
              <span class="body-bold">{{ sumCritical() }}</span>
              @if (isDesktop()) {
                <span class="body-bold sub-title-status">{{
                  i18n.langString("critical")
                }}</span>
              }
            </ng-template>
          }

          @if (sumWarning() > 0) {
            <div
              class="clickable"
              role="button"
              tabindex="0"
              (click)="onSetWarningFilter()"
              (keyup.enter)="onSetWarningFilter()"
              (keydown.enter)="onSetWarningFilter()"
            >
              <nz-alert
                nzType="warning"
                class="nz-status-report"
                [nzMessage]="warningTemplate"
              ></nz-alert>
            </div>
            <ng-template #warningTemplate>
              <i
                nz-icon
                nzType="icons:status-exclamation-octagon"
                class="svg-icon fillorange"
              ></i>
              <span class="body-bold">{{ sumWarning() }}</span>
              @if (isDesktop()) {
                <span class="body-bold sub-title-status">{{
                  i18n.langString("warning")
                }}</span>
              }
            </ng-template>
          }

          @if (sumWorking() > 0) {
            <div
              class="clickable"
              role="button"
              tabindex="0"
              (click)="onSetWorkingFineFilter()"
              (keyup.enter)="onSetWorkingFineFilter()"
              (keydown.enter)="onSetWorkingFineFilter()"
            >
              <nz-alert
                nzType="success"
                class="nz-status-report"
                [nzMessage]="otherfineTemplate"
              ></nz-alert>
            </div>
            <ng-template #otherfineTemplate>
              <i
                nz-icon
                nzType="icons:status-check"
                class="svg-icon fillgreen"
              ></i>
              <span class="body-bold">{{ sumWorking() }}</span>
              @if (isDesktop()) {
                <span class="body-bold sub-title-status">{{
                  i18n.langString("working_fine")
                }}</span>
              }
            </ng-template>
          }
          @if (sumArchived() > 0) {
            <div
              class="clickable"
              role="button"
              tabindex="0"
              (click)="onSetArchivedFilter()"
              (keyup.enter)="onSetArchivedFilter()"
              (keydown.enter)="onSetArchivedFilter()"
            >
              <nz-alert
                nzType="info"
                class="nz-status-report"
                [nzMessage]="archivedTemplate"
              ></nz-alert>
            </div>
            <ng-template #archivedTemplate>
              <i nz-icon nzType="icons:folder" class="svg-icon"></i>
              <span class="body-bold">{{ sumArchived() }}</span>
              @if (isDesktop()) {
                <span class="body-bold sub-title-status">{{
                  i18n.langString("deinstalled")
                }}</span>
              }
            </ng-template>
          }
        </div>
      }
    </div>
  }
  <!-- Satellite Button for Mobile/Tablet -->
  @if (isMobile() || isTablet()) {
    <div
      class="satellite-btn-container"
      [class.mobile]="isMobile()"
      [class.tablet]="isTablet()"
    >
      <!-- <button
        id="satellite"
        class="drop-shadow"
        (click)="satelliteView.update((value) => !value)"
      >
        @if (!satelliteView()) {
          <i nz-icon nzType="icons:satellite"></i>
        }
        @if (satelliteView()) {
          <i nz-icon nzType="icons:map"></i>
        }
      </button> -->
    </div>
  }

  <!-- Map Overlay -->
  <app-map-overlay
    [OverlayPlant]="OverlayPlant"
    (close)="OverlayPlant = null"
  ></app-map-overlay>

  <!-- Map Component -->
  <app-map
    [class.desktop]="isDesktop()"
    [class.mobile]="!isDesktop()"
    [plants]="plants()"
    [loading]="loading() || loadingThumbnails()"
    [satelliteView]="satelliteView()"
    (markerClick)="onMapMarkerClick($event)"
    [infoOverlay]="filteredPlants()"
  ></app-map>

  <!-- Satellite Button for Desktop -->
  @if (isDesktop()) {
    <div class="satellite-btn-container" [class.desktop]="isDesktop()">
      <!-- <button
        id="satellite"
        class="drop-shadow"
        (click)="satelliteView.update((value) => !value)"
      >
        @if (!satelliteView()) {
          <i nz-icon nzType="icons:satellite"></i>
          <span class="body-bold">{{ i18n.langString("satellite_view") }}</span>
        }
        @if (satelliteView()) {
          <i nz-icon nzType="icons:map"></i>
          <span class="body-bold">{{ i18n.langString("map_view") }}</span>
        }
      </button> -->
    </div>
  }
}
